import { VEHICLE_TYPE_NOT_DETECTED_MESSAGE } from "../components/VehicleNotIdentifiedModal/VehicleNotIdentifiedModal";

export const ALREADY_INSPECTED_MESSAGE = 'Vistoria já foi realizada para esse usuário.';

export type UploadErrorKind =
  | 'already-inspected'
  | 'vehicle-type'
  | 'validation'
  | 'rate-limited'
  | 'unauthorized'
  | 'recoverable';

export function classifyUploadError(error: any): UploadErrorKind {
  const statusCode: number = Number(error?.status) || 0;

  let message: string | undefined;
  try {
    const parsed = error?.response ? JSON.parse(error.response) : {};
    message = parsed.message;
  } catch (e) {
    message = undefined;
  }

  if (statusCode === 429) return 'rate-limited';
  if (statusCode === 401 || statusCode === 403) return 'unauthorized';
  if (statusCode === 400 && message === ALREADY_INSPECTED_MESSAGE) return 'already-inspected';
  if (statusCode === 400 && message === VEHICLE_TYPE_NOT_DETECTED_MESSAGE) return 'vehicle-type';
  if (statusCode >= 400 && statusCode < 500) return 'validation';
  return 'recoverable';
}

export function getRetryAfterSeconds(error: any, fallbackSeconds: number = 60): number {
  const parsed = Number(error?.retryAfter);
  return parsed > 0 ? parsed : fallbackSeconds;
}
